module.exports = __webpack_public_path__ + "static/media/house-day.f019e0ef.svg";